import { useEffect } from 'react';

const AnalyticsAndWidgets = () => {
  useEffect(() => {
    // Load UserWay Accessibility Menu
    if (!document.querySelector('script[src*="userway.org"]')) {
      const s = document.createElement('script');
      s.setAttribute('data-account', 'RF3LDqOACA');
      s.src = 'https://cdn.userway.org/widget.js';
      document.body.appendChild(s);
    }

    document.addEventListener('userway:init_completed', function(event) {
      const instance = event.detail.userWayInstance;
      instance.iconVisibilityOff();
    });
  }, []);

  return null;
};

export default AnalyticsAndWidgets;
